export default "__VITE_ASSET__9c5d8b1d__"